import { render, staticRenderFns } from "./ComposeTextPane.vue?vue&type=template&id=154272e0&scoped=true"
import script from "./ComposeTextPane.vue?vue&type=script&lang=js"
export * from "./ComposeTextPane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154272e0",
  null
  
)

export default component.exports